const route = {
	path: '/customers',
	name: 'customers',
	meta: {
		noChangeCompany: true,
		title: 'Compañías',
	},
	component: () => import('@/pages/customers/page-customer'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/customers.js